import styled from "styled-components";
import { mediaMax } from "components/designV2/breakpoints";
import { Text } from "components/designV2/text/text";
import { ColorV2 } from "config/colors";
import { SimpleRow } from "../../organizationalStructure/organizationalStructure.styled";

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 0;
  padding: 0;
  background-color: transparent;
  box-shadow: none;
  overflow: visible;
  gap: 16px;

  ${mediaMax.tablet} {
    gap: 12px;
  }
`;

export const ChooseWorkersContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 2px;
`;

export const ChooseWorkerSearchWrap = styled.div`
  flex: 0 1 520px;
  width: 100%;
  min-width: 0;
  max-width: 520px;

  @media (max-width: 1366px), (max-height: 900px) {
    max-width: 500px;
  }

  @media (max-width: 1024px), (max-height: 760px) {
    max-width: 440px;
  }
`;

export const ScheduleMultipleButtonWrap = styled.div`
  margin-bottom: 0;
  margin-left: 12px;
  flex-shrink: 0;
`;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export const ListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .checkbox-component {
    margin-top: 20px;
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  align-items: flex-start;
  row-gap: 4px;
`;

export const TabsContainer = styled.div`
  margin-bottom: 0;
`;

export const TabsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const VisibleForDropdownWrap = styled.div`
  width: 180px;
`;

export const TabLabel = styled(Text)`
  margin-bottom: 10px;
`;

export const SectionCard = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  border: none;
  border-radius: 12px;
  background: ${ColorV2.Blue7};
  padding: 14px;

  ${mediaMax.tablet} {
    padding: 12px;
    border-radius: 10px;
  }
`;

export const SectionTitle = styled(Text)`
  margin-bottom: 0;
`;

export const SectionHeaderRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SectionMetrics = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  padding-right: 12px;
`;

export const FormFlow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RoleRow = styled(SimpleRow)`
  justify-content: flex-start;
`;

export const RecruitTopRow = styled(SimpleRow)`
  width: 100%;
  align-items: flex-start;
  gap: 32px;
`;

export const SegmentControllerWrapper = styled.div`
  margin-right: 20px;
`;

export const PublicSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RecruitIntroCard = styled.div`
  width: 100%;
  background: ${ColorV2.Blue7};
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  .drop-down-with-label {
    max-width: none;
    margin-right: 0;
    margin-bottom: 0;
  }

  .drop-down-with-label > div[role="button"] {
    background: ${ColorV2.White};
    border: 1.5px solid ${ColorV2.Blue5};
    border-radius: 16px;
    min-height: 52px;
  }
`;

export const PaymentCard = styled.div`
  width: 100%;
  background: ${ColorV2.Blue7};
  border-radius: 12px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DescriptionFieldWrap = styled.div`
  width: 100%;
  max-width: 100%;

  textarea {
    min-height: 138px;
    max-height: 220px;
    resize: vertical;
    border-radius: 16px;
    padding: 16px 22px;
  }
`;

export const AddMoreShiftsRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 8px;
`;

export const PaymentTypeHeading = styled(Text)`
  margin-bottom: 0;
`;

export const PaymentTypeRow = styled(SimpleRow)`
  margin-top: 5px;
  margin-bottom: 0;
`;

export const PaymentTypeOptionWrap = styled.div`
  margin-right: 15px;
`;

export const WorkerListWrap = styled.div`
  margin-top: 12px;
`;
